import { createReducer, on } from '@ngrx/store';
import * as menuActions from 'src/app/STORE/actions/menu.actions';

export interface MenuState {
  collapsedMenu: boolean;
  menuData?: any[];
  toggleSideBar?: any;
}

export const initialState: MenuState = {
  collapsedMenu: false,
  menuData: [],
  toggleSideBar: {}
};

export const menuReducer = createReducer(
  initialState,
  on(menuActions.clickHamburger, (state, { collapsedMenu }) => ({
    ...state,
    collapsedMenu
  })),
  on(menuActions.getMenuData, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(menuActions.setMenuData, (state, { menuData }) => {
    return {
      ...state,
      ...{
        menuData
      }
    };
  }),
  on(menuActions.toggleSideBar, (state, { toggleSideBar }) => ({
    ...state,
    toggleSideBar
  }))
);
